import { isFeatureEnabled } from "./appConfigurations";

// Gates the Site ID search in Access Rights (CS AB#49783): a site is also found by
// its Site ID, with the Site list's partial match. Off = the search as it was.
export const ACCESS_RIGHTS_SITE_ID_SEARCH_FEATURE_FLAG = "CS_49783_ACCESS_RIGHTS_SITE_ID_SEARCH";

export const selectAccessRightsSiteIdSearchEnabled = isFeatureEnabled(
  ACCESS_RIGHTS_SITE_ID_SEARCH_FEATURE_FLAG
);
